module.exports = __webpack_public_path__ + "static/media/GH_Logotype_Rebrand_Orange_RGB.70106d73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GH_Logotype_Rebrand_Orange_RGB.svg
// module id = 46
// module chunks = 0